import { Grid } from '@mui/material'

import { Map } from 'features/maps/types'
import CardGroupHeader from 'features/common/ui/Cards/CardGroupHeader/CardGroupHeader'

import MapSampleCard from '../MapSampleCard/MapSampleCard'
import { openNewWindow } from 'features/common/utils/navigationUtils'
import { BuilderPaths } from 'features/builder/paths'

const URL_BASE_FOR_MAP = 'https://clausa.app.carto.com/'

export const SAMPLE_MAPS: Array<Map> = [
  {
    id: '968c03bd-375c-4ec1-92e4-a4caef6efbfb',
    title: 'Galapagos',
    description: 'Galapagos contour lines',
    thumbnailUrl:
      'https://storage.googleapis.com/carto-tnt-gcp-us-east1-thumbnails-storage/thumbnails/ac_lqe3zwgu/968c03bd-375c-4ec1-92e4-a4caef6efbfb.png'
  },
  {
    id: '378446a5-9e05-4aef-9e88-7d89ec438c32',
    title: 'COVID',
    description: 'COVID vaccination in the US',
    thumbnailUrl:
      'https://storage.googleapis.com/carto-tnt-gcp-us-east1-thumbnails-storage/thumbnails/ac_lqe3zwgu/378446a5-9e05-4aef-9e88-7d89ec438c32.png'
  },
  {
    id: '6739b4a0-576a-46b6-b9ca-c44937f74551',
    title: 'H3',
    description: 'H3 aggregation example',
    thumbnailUrl:
      'https://storage.googleapis.com/carto-tnt-gcp-us-east1-thumbnails-storage/thumbnails/ac_lqe3zwgu/6739b4a0-576a-46b6-b9ca-c44937f74551.png'
  },
  {
    id: '65142cd5-8680-4998-887b-22162d3fb236',
    title: 'OSM',
    description: 'Buildings in OpenStreetMap',
    thumbnailUrl:
      'https://storage.googleapis.com/carto-tnt-gcp-us-east1-thumbnails-storage/thumbnails/ac_lqe3zwgu/65142cd5-8680-4998-887b-22162d3fb236.png'
  }
]

function MapsSample() {
  return (
    <Grid item>
      <CardGroupHeader pretitleId="maps.sample.overline" titleId="maps.sample.title" />
      <Grid container spacing={3}>
        {SAMPLE_MAPS.map((map) => (
          <Grid item xs={12} sm={6} lg={4} xl={3} key={map.id}>
            <MapSampleCard
              onClick={() => {
                const mapPublicUrl = `${URL_BASE_FOR_MAP}/${BuilderPaths.PublicMap(map.id)}`
                openNewWindow(mapPublicUrl)
              }}
              map={map}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}
export default MapsSample
